import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import classNames from 'classnames';
import React from "react";
import "./index.scss";
export function SkeletonSingle(props) {
  var width = props.width,
    _props$height = props.height,
    height = _props$height === void 0 ? 20 : _props$height,
    className = props.className,
    style = props.style;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('skeleton-scope', className),
    style: _objectSpread({
      width: width,
      height: height
    }, style)
  });
}